import { SurveyList } from '../model/survey-list';
import { SurveyBuilder } from '../builders/survey-builder';
import * as _ from 'lodash-es';
export class SurveyListBuilder {
    static buildSurveyList(data) {
        const surveyList = new SurveyList();
        surveyList.page = data.page;
        surveyList.pagination = data.pagination;
        surveyList.total = data.total;
        surveyList.total_pages = data.total_pages;
        surveyList.surveys = _.map(data.surveys, (survey) => {
            return SurveyBuilder.buildSurvey(survey);
        });
        return surveyList;
    }
}
//# sourceMappingURL=survey-list-builder.js.map